const initialState = {
  students: [],
  isClassBadge: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_BADGING_STATE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
